module.exports = __webpack_public_path__ + "img/newcommunity.0eb0aae6.png";